module.exports = __webpack_public_path__ + "img/6@2x.f8917d75.png";